import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  name() {
    return faker.company.name();
  },

  shortName() {
    return this.name.substring(0, 4);
  },

  city() {
    return faker.address.city();
  },

  street() {
    return faker.address.street();
  },

  zipcode() {
    return faker.address.zipCode('#####');
  },

  fon() {
    return faker.phone.number('+49 ## #### ####');
  },

  fax() {
    return faker.phone.number('+49 ## #### ####');
  },

  email() {
    return faker.internet.email(this.name);
  },

  text() {
    return faker.lorem.paragraphs(2);
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(organization, server) {
    organization.update({
      linkId: server.create('link'),
      categoryId: server.create('category', 'country'),
    });
  },
});
